module.exports = __webpack_public_path__ + "static/media/gcp.708741c5.jpeg";